import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import confirmIcon from '../assets/confirm.png';
import warningIcon from '../assets/warning_sign.png';
import eyeIcon from '../assets/eye.png';
import hideIcon from '../assets/hide.png';

export default function AuthModal({ isOpen, onClose }) {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [newsletter, setNewsletter] = useState(true);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  
  const { login, register } = useAuth();

  if (!isOpen) return null;

  const validatePassword = (pass) => {
    const hasLetter = /[a-zA-Z]/.test(pass);
    const hasNumber = /[0-9]/.test(pass);
    const isLongEnough = pass.length >= 8;
    
    return hasLetter && hasNumber && isLongEnough;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setPasswordError('');

    if (!isLogin && !validatePassword(password)) {
      setPasswordError('Password should contain both letters and numbers, with minimum length of 8 characters');
      setLoading(false);
      return;
    }
    
    if (!isLogin && !newsletter) {
      setError('Пожалуйста, подтвердите подписку на рассылку');
      return;
    }
    
    setLoading(true);

    try {
      const result = isLogin 
        ? await login(email, password)
        : await register(email, password);

      if (result.success) {
        onClose();
        setEmail('');
        setPassword('');
        setNewsletter(true);
      } else {
        setError(result.message || 'Произошла ошибка');
      }
    } catch (err) {
      setError('Произошла ошибка');
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const switchMode = (loginMode) => {
    setIsLogin(loginMode);
    setError('');
    setPasswordError('');
    setNewsletter(true);
  };

  // Базовые размеры для 1920x1080
  const baseWidth = 660;
  const baseHeightSignIn = 615;
  const baseHeightSignUp = 780;
  const baseScreenWidth = 1920;
  
  // Вычисляем масштаб относительно ширины экрана
  const scale = window.innerWidth / baseScreenWidth;
  
  // Применяем масштаб к размерам
  const modalWidth = baseWidth * scale;
  const modalHeight = isLogin ? baseHeightSignIn * scale : baseHeightSignUp * scale;

  return (
    <div 
      className="fixed inset-0 bg-black/60 flex items-start justify-center z-50 p-4 pt-[10vh]"
      onClick={handleBackdropClick}
    >
      <div 
        className="bg-[#191919] rounded-[30px] border border-[#414141] relative"
        style={{
          width: `${modalWidth}px`,
          height: `${modalHeight}px`,
          minWidth: '660px',
          minHeight: isLogin ? '615px' : '780px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Sign In Text */}
        <button
          onClick={() => switchMode(true)}
          className="absolute"
          style={{
            left: '157px',
            top: '45px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 'bold',
            fontSize: '24px',
            color: isLogin ? '#FFFFFF' : '#808080',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            zIndex: 10
          }}
        >
          Sing In
        </button>

        {/* Sign Up Text */}
        <button
          onClick={() => switchMode(false)}
          className="absolute"
          style={{
            left: '411px',
            top: '45px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 'bold',
            fontSize: '24px',
            color: isLogin ? '#808080' : '#FFFFFF',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            zIndex: 10
          }}
        >
          Sing Up
        </button>

        {/* Blue underline */}
        <div 
          className="absolute rounded-full"
          style={{
            width: '110px',
            height: '4px',
            backgroundColor: '#3365E6',
            left: isLogin ? '145px' : '405px',
            top: '104px'
          }}
        />

        {/* Line under tabs */}
        <div 
          className="absolute"
          style={{
            width: '470px',
            height: '1px',
            backgroundColor: '#D9D9D9',
            opacity: '0.4',
            left: '95px',
            top: '108px'
          }}
        />

        {/* Google Sign In Button */}
        <button 
          className="absolute rounded-[30px] flex items-center justify-center hover:opacity-90"
          style={{
            width: '415px',
            height: '53px',
            left: '122px',
            top: '140px',
            backgroundColor: 'transparent',
            border: '3px solid #555555'
          }}
          onClick={() => alert('Google OAuth пока не реализован')}
        >
          <span 
            style={{
              fontFamily: 'Kumbh Sans, sans-serif',
              fontWeight: 'bold',
              fontSize: '26px',
              color: '#FFFFFF',
              opacity: 0.6,
              marginRight: '10px'
            }}
          >
            G
          </span>
          <span 
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#FFFFFF',
              opacity: 0.6
            }}
          >
            Sing In with Google
          </span>
        </button>

        {/* Divider with OR */}
        <div 
          className="absolute flex items-center"
          style={{
            width: '535px',
            left: '63px',
            top: '225px'
          }}
        >
          <div style={{ flex: 1, height: '1px', backgroundColor: '#D9D9D9', opacity: 0.4 }} />
          <span 
            style={{
              margin: '0 15px',
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#D9D9D9',
              opacity: 0.4
            }}
          >
            OR
          </span>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#D9D9D9', opacity: 0.4 }} />
        </div>

        <form onSubmit={handleSubmit} className="w-full h-full relative" noValidate>
          {/* Email Label */}
          <label 
            className="absolute"
            style={{
              left: '102px',
              top: '270px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: '500',
              fontSize: '16px',
              color: '#FFFFFF',
              opacity: 0.8
            }}
          >
            Email:
          </label>

          {/* Email Input */}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="absolute rounded-[8px] text-white placeholder-white/30 focus:outline-none"
            style={{
              width: '500px',
              height: '50px',
              left: '80px',
              top: '300px',
              backgroundColor: 'rgba(76, 76, 76, 0.4)',
              paddingLeft: '20px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: '500',
              fontSize: '16px',
              border: error ? '2px solid #BA0303' : 'none'
            }}
            placeholder="Email:"
            required
          />

          {/* Password Label */}
          <label 
            className="absolute"
            style={{
              left: '102px',
              top: '375px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: '500',
              fontSize: '16px',
              color: '#FFFFFF',
              opacity: 0.8
            }}
          >
            Password:
          </label>

          {/* Password Input */}
          <div className="absolute" style={{ left: '80px', top: '405px', width: '500px', height: '50px' }}>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              className="rounded-[8px] text-white placeholder-white/30 focus:outline-none"
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(76, 76, 76, 0.4)',
                paddingLeft: '20px',
                paddingRight: '80px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: '500',
                fontSize: '16px',
                border: (error && isLogin) ? '2px solid #BA0303' : 'none'
              }}
              placeholder="Password:"
              required
              minLength="8"
            />
            
            {/* Hide icon (right) */}
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute"
              style={{
                right: '15px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <img 
                src={showPassword ? eyeIcon : hideIcon}
                alt={showPassword ? "show" : "hide"}
                style={{
                  width: '26px',
                  height: '26px',
                  opacity: 0.6
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </button>
          </div>

          {/* Error Message for Sign In */}
          {error && isLogin && (
            <div 
              className="absolute flex items-start"
              style={{
                left: '107px',
                top: '465px',
                width: '445px',
                fontFamily: 'Inria Sans, sans-serif',
                fontSize: '14px',
                color: '#FF0000',
                opacity: 0.8
              }}
            >
              <img 
                src={warningIcon}
                alt="warning"
                style={{
                  width: '16px',
                  height: '16px',
                  marginRight: '4px',
                  marginTop: '3px',
                  flexShrink: 0,
                  filter: 'brightness(0) saturate(100%) invert(16%) sepia(100%) saturate(7418%) hue-rotate(0deg) brightness(102%) contrast(118%)',
                  opacity: 0.8
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <span>Your email and password does not match. Please try again.</span>
            </div>
          )}

          {/* Forgot Password - только для Sign In */}
          {isLogin && (
            <button
              type="button"
              className="absolute hover:opacity-80"
              style={{
                left: '400px',
                top: '375px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 'bold',
                fontSize: '16px',
                color: '#3365E6',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                zIndex: 10
              }}
              onClick={() => alert('Восстановление пароля пока не реализовано')}
            >
              Forgot Password?
            </button>
          )}

          {/* Password Hint for Sign Up */}
          {!isLogin && passwordError && (
            <div 
              className="absolute flex items-start"
              style={{
                left: '107px',
                top: '465px',
                width: '470px',
                fontFamily: 'Inria Sans, sans-serif',
                fontSize: '14px',
                color: '#FF0000',
                opacity: 0.8
              }}
            >
              <img 
                src={warningIcon}
                alt="warning"
                style={{
                  width: '16px',
                  height: '16px',
                  marginRight: '4px',
                  marginTop: '3px',
                  flexShrink: 0,
                  filter: 'brightness(0) saturate(100%) invert(16%) sepia(100%) saturate(7418%) hue-rotate(0deg) brightness(102%) contrast(118%)',
                  opacity: 0.8
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <span>{passwordError}</span>
            </div>
          )}

          {/* Newsletter Subscription Box - только для Sign Up */}
          {!isLogin && (
            <div 
              className="absolute rounded-[6px] border border-[#356DFD]"
              style={{
                width: '498px',
                height: '150px',
                left: '80px',
                top: '510px',
                backgroundColor: 'rgba(53, 109, 253, 0.1)'
              }}
            >
              {/* Confirm Button */}
              <button
                type="button"
                className="rounded-[4px] hover:opacity-90 absolute flex items-center justify-center"
                style={{
                  width: '147px',
                  height: '35px',
                  backgroundColor: '#356DFD',
                  left: '25px',
                  top: '17px',
                  border: 'none',
                  cursor: 'pointer',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '500',
                  fontSize: '16px',
                  color: '#FFFFFF'
                }}
                onClick={() => setNewsletter(!newsletter)}
              >
                <span style={{ paddingRight: '20px' }}>Confirm</span> {/* Добавляем отступ справа */}

                {/* Checkbox внутри кнопки */}
                <div
                  className="absolute"
                  style={{
                    width: '20px',
                    height: '19px',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: 'rgba(255, 0, 0, 0.15)',
                    borderRadius: '2px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {newsletter && (
                    <img 
                      src={confirmIcon} 
                      alt="confirmed"
                      style={{
                        width: '12px',
                        height: '12px',
                        objectFit: 'contain'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                </div>
              </button>

              {/* Newsletter Text */}
              <p 
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: '400',
                  fontSize: '16px',
                  color: '#FFFFFF',
                  lineHeight: '1.4',
                  margin: '0',
                  position: 'absolute',
                  left: '28px',
                  top: '60px',
                  width: '450px'
                }}
              >
                Please keep me updated by email with the latest NFT news, research findings, reward programs, event updates, collection listings and more information.
              </p>
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="absolute rounded-[5px] text-white font-bold hover:opacity-90 disabled:opacity-50 flex items-center justify-center"
            style={{
              width: '148px',
              height: '43px',
              left: '404px',
              top: isLogin ? '490px' : '677px',
              backgroundColor: '#356DFD',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 'bold',
              fontSize: '20px',
              zIndex: 15
            }}
          >
            {loading ? 'Loading...' : (isLogin ? 'Sing In' : 'Sing Up')}
          </button>
        </form>

        {/* Terms Text */}
        <p 
          className="absolute text-center"
          style={{
            top: isLogin ? '575px' : '747px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '15px',
            color: '#FFFFFF',
            opacity: 0.4,
            width: '100%'
          }}
        >
          By proceeding, you agree to Terms of Use & Privacy Policy.
        </p>
      </div>
    </div>
  );
}